module.exports = __webpack_public_path__ + "img/icon-edit.c9f36793.svg";